<template>
  <div>
    <img :src="imgSrc" alt="" style="width: 50px" @click="onResimGoster" />
    <b-modal
        ref="modal-resim"
        id="modal-primary"
        modal-class="modal-primary"
        size="lg"
        centered
        title="BootstrapVue"
        hide-footer
        hide-header
      >
        <img :src="imgSrc" style="width: 100%" />
      </b-modal>
  </div>

</template>
<script>
export default {
  data() {
    return {
      imgSrc: "",
      imgSrcUrl: "https://servis.kamyonyedekparca.com",
    };
  },
  created() {
    var changedPicture = this.params.data.RESIM;
    if (this.params.data.RESIM.toString().includes("~") == true) {
      changedPicture = this.params.data.RESIM.toString().replace("~", "");
    }
    this.imgSrc = this.imgSrcUrl + changedPicture;
  },
  methods:{
    onResimGoster() {
      this.$refs["modal-resim"].show();
    },
  }
};
</script>